// Items nuevos (ids 48-60) compartidos por detailedCar y detailedCarUser.
const I = "/assets/icons/featureList/";

type ExtraItem = { item: number; title: string; icon: string };

export const CHARACTERISTICS_EXTRA: ExtraItem[] = [
    { item: 48, title: "Suspensión delantera", icon: `${I}suspension-delantera.svg` },
    { item: 49, title: "Suspensión trasera", icon: `${I}suspension-trasera.svg` },
    { item: 55, title: "Capacidad de batería", icon: `${I}bateria.svg` },
    { item: 56, title: "Autonomía", icon: `${I}bateria.svg` },
];

export const SECURITY_EXTRA: ExtraItem[] = [
    { item: 50, title: "Control de tracción", icon: `${I}control-traccion.svg` },
    { item: 58, title: "Asistencias a la conducción", icon: `${I}asistencias-conduccion.svg` },
    { item: 59, title: "Sensores", icon: `${I}sensores.svg` },
];

export const ACCESSORIES_EXTRA: ExtraItem[] = [
    { item: 51, title: "Pantalla", icon: `${I}pantalla.svg` },
    { item: 52, title: "Modos de conducción", icon: `${I}modos-conduccion.svg` },
    { item: 53, title: "Sistema ABS", icon: `${I}sistema-abs.svg` },
    { item: 54, title: "Iluminación", icon: `${I}iluminacion.svg` },
    // shortcut: sin ícono propio en Figma, reutiliza el de aire acondicionado; cambiar cuando diseño lo entregue
    { item: 60, title: "Climatización", icon: `${I}air.png` },
];

// Devuelve solo los items que el vehículo realmente tiene.
export const withContent = (description: any[], items: ExtraItem[]) =>
    items
        .map(({ item, title, icon }) => ({
            icon,
            title,
            content: description?.find((d) => d?.item === item)?.content,
        }))
        .filter((i) => i.content);
